import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export const customerFormTablesService = async (): Promise<ResponseAPI> => {
  const response = await api.get('tabelascadastrocliente')

  return response.data
}
